"use client";
import React, { useEffect, useRef } from "react";
import { Carousel } from "..";
import { DrinkTypeProps } from "@/interface";
import { useGlobalContext } from "@/contexts/AppContext";
import { footerNavItems } from "@/mock";
import { footerNavItemsProps } from "@/interface/home";
import Link from "next/link";
import Image from "next/image";
import styles from "./Footer.module.scss";

const Footer = ({ type }: DrinkTypeProps) => {
	const { setCategoryHeight } = useGlobalContext();
	const footerRef = useRef<HTMLDivElement>(null);
	useEffect(() => {
		const heightOfComponent = footerRef.current?.offsetHeight;
		setCategoryHeight(heightOfComponent);
	}, [setCategoryHeight]);

	return (
		<footer className={styles.footer} ref={footerRef}>
			<div className={styles.footer_body}>
				<div className={styles.footer_nav}>
					<div className={styles.address}>
						<h3>Store Locations</h3>
						<p>11 Akindele road, New garage Lagos</p>
						<h6>Shop CO34 and CO36 Dawaki ultra modern market</h6>
					</div>
					<div className={styles.company_support}>
						<div className={styles.company}>
							<h3>Company</h3>
							<Link target="_parent" href="/home">
								<p>Home</p>
							</Link>
							<Link target="_parent" href="/about-us">
								<p>About Us</p>
							</Link>
						</div>
						<div className={styles.support}>
							<h3>Support</h3>
							<Link target="_parent" href="/contact-us">
								<p>Contact us</p>
							</Link>
							<Link target="_parent" href="/blog">
								<p>Blog</p>
							</Link>
						</div>
					</div>
					<div className={styles.socials}>
						<h3>Social Media</h3>
						<div className={styles.icons}>
							{footerNavItems.map(
								(item: footerNavItemsProps, index: number) => {
									return (
										<Link target="blank" href={item.link} key={index}>
											<div className={styles.icon}>
												<Image
													alt="icon"
													src={item.imgSrc}
													fill
												/>
											</div>
										</Link>
									);
								}
							)}
						</div>
					</div>
				</div>
			</div>
			<div className={styles.carousel_container}>
				<Carousel
					icon1={
						type === "soft" ? "/svgs/StarOrange.svg" : "/svgs/whiteStar.svg"
					}
					icon2={
						type === "soft" ? "/svgs/StarOrange.svg" : "/svgs/whiteStar.svg"
					}
					title="sippy life"
					type="big"
				/>
			</div>

			<div className={styles.copyright}>
				<h3>© Copyright - Sippy Life 2025 | All rights reserved</h3>
			</div>
		</footer>
	);
};

export default Footer;
